import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

/** L'historique des corrections de score d'un suivi (#161), la plus récente en tête. */
export const GQL_SCORE_CORRECTIONS = typedGql('query', { scalars })({
  scoreCorrections: [
    { trackingId: $('trackingId', 'ID!') },
    { id: true, createdAt: true, score: true, previousScore: true, reason: true, correctedBy: true, revokedAt: true, revokedBy: true },
  ],
})

export const GQL_CORRECT_SCORE = typedGql('mutation', { scalars })({
  correctScore: [{ input: $('input', 'CorrectScoreInput!') }, true],
})

export const GQL_REVOKE_SCORE_CORRECTION = typedGql('mutation', { scalars })({
  revokeScoreCorrection: [{ trackingId: $('trackingId', 'ID!') }, true],
})
